import { useQuery } from "@tanstack/react-query";
import {
  RecommendationDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_RECOMMENDATIONS } from "../domain";

import { Error } from "@helpers";
import { recommendationsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const fetchRecommendations = async (): Promise<RecommendationDto[] | undefined> => {
  try {
    const response =
      await recommendationsApi.recommendationsControllerGetRecommendations();

    const data = response.data;

    if (response.status === 200 && data) {
      return data;
    }
  } catch (error) {
    Error(error);
  }
};

export const useRecommendationsApi = (
  user: UserProfileDto | null,
): {
  recommendations?: RecommendationDto[];
  recommendationsEnabled: boolean;
  isLoadingRecommendations: boolean;
  isFetchingRecommendations: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isLoading, isFetching, data } = useQuery({
    queryKey: [DOMAIN_RECOMMENDATIONS],
    queryFn: fetchRecommendations,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    recommendations: data,
    recommendationsEnabled: enabled,
    isLoadingRecommendations: isLoading,
    isFetchingRecommendations: isFetching,
  };
};
